import { createReducer } from "@reduxjs/toolkit";
import { clearActivityLogList, getActivityLogListSuccess, loadingList } from "./activityLogActions";
  export interface IEmailHistoryState {
    activityLogList?: Array<any>;
    dataCount: number;
    isLoading?: boolean;
  }
  const initialState: IEmailHistoryState = {
    activityLogList: [],
    dataCount: 0,
    isLoading: false,
  };
  export const ActivityLogReducer = createReducer(initialState, (builder) => {
    builder
      
      .addCase(getActivityLogListSuccess, (state, action) => {
        state = {
          ...state,
          activityLogList: action.payload?.data,
          dataCount: action.payload?.dataCount,
        };
        return state;
     })
    .addCase(loadingList, (state, action) => {
        state.isLoading = action.payload; 
        })
    .addCase(clearActivityLogList, (state) => {
      state.activityLogList = []; 
      state.dataCount = 0;
    });
    });
  